var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotionOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 47.9983C37.2535 47.9983 47.9983 37.2535 47.9983 23.9992C47.9983 10.7448 37.2535 0 23.9992 0C10.7448 0 0 10.7448 0 23.9992C0 37.2535 10.7448 47.9983 23.9992 47.9983Z",
    fill: "#D8D8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86302 15.9178C4.05728 14.1474 4.70426 12.4531 5.59112 10.9007C6.48811 9.35165 7.65538 7.9462 9.01523 6.76372C10.3734 5.57956 11.9258 4.61665 13.5846 3.94264C15.2452 3.27708 17.0138 2.87335 18.7943 2.93248C17.252 3.81426 15.7959 4.63017 14.4208 5.54912C13.0441 6.45794 11.7501 7.43774 10.5254 8.50028C9.3007 9.5645 8.15032 10.7115 7.05907 11.9497C5.95767 13.1846 4.94752 14.5123 3.86133 15.9178H3.86302Z",
    fill: "#BCBBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9984 23.9994C47.9984 37.2533 37.2548 48.0002 23.9976 48.0002C16.7541 48.0002 10.2606 44.7906 5.8584 39.7145C10.0697 43.3818 15.5767 45.5981 21.5988 45.5981C34.8527 45.5981 45.5997 34.8545 45.5997 21.5973C45.5997 15.592 43.3952 10.1019 39.7464 5.89062C44.8023 10.2894 47.9967 16.7694 47.9967 23.9977L47.9984 23.9994Z",
    fill: "#D8D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9984 23.9994C47.9984 37.2533 37.2548 48.0002 23.9976 48.0002C16.7541 48.0002 10.2606 44.7906 5.8584 39.7145C10.0697 43.3818 15.5767 45.5981 21.5988 45.5981C34.8527 45.5981 45.5997 34.8545 45.5997 21.5973C45.5997 15.592 43.3952 10.1019 39.7464 5.89062C44.8023 10.2894 47.9967 16.7694 47.9967 23.9977L47.9984 23.9994Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7543 26.533C34.5035 26.533 35.9216 24.4895 35.9216 21.9687C35.9216 19.4478 34.5035 17.4043 32.7543 17.4043C31.005 17.4043 29.5869 19.4478 29.5869 21.9687C29.5869 24.4895 31.005 26.533 32.7543 26.533Z",
    fill: "#6F79D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2435 26.533C16.9928 26.533 18.4109 24.4895 18.4109 21.9687C18.4109 19.4478 16.9928 17.4043 15.2435 17.4043C13.4942 17.4043 12.0762 19.4478 12.0762 21.9687C12.0762 24.4895 13.4942 26.533 15.2435 26.533Z",
    fill: "#6F79D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1152 37.2684C17.5731 32.5537 29.6647 30.1499 33.1463 32.8307C33.4807 33.0875 33.4132 33.6095 33.0213 33.7683C32.9486 33.797 32.8709 33.8105 32.7932 33.8071C25.798 33.4777 19.9785 34.3629 16.1152 37.2684Z",
    fill: "#6F79D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionOk);
export default __webpack_public_path__ + "static/media/emotion-ok.6e06e3f3d43184a4633674ff6a584ef0.svg";
export { ForwardRef as ReactComponent };